module.exports = __webpack_public_path__ + "static/media/billboard-light.8dd4d2c1.svg";